/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Err_Skip_Reason_InvalidInputs */

const vi_einvoice_err_skip_reason_invalid = /** @type {(inputs: Einvoice_Err_Skip_Reason_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chọn lý do`)
};

/**

* @param {Einvoice_Err_Skip_Reason_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_skip_reason_invalid = /** @type {((inputs?: Einvoice_Err_Skip_Reason_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Skip_Reason_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_skip_reason_invalid(inputs)
});